import { useEffect, useState } from 'react';
import styles from './settings.module.scss';
import TextFieldShared from "../../../components/TextField/TextField";
import { SettingsPageProps } from '../../../interfaces/pages';
import { useToast } from '../../../helpers/hooks';
import Icon from '@mdi/react';
import { mdiLockOutline, mdiEmailOutline, mdiChevronRight, mdiChevronDown } from '@mdi/js';

const emptyPassState = {
    value: "",
    error: "",
    validation: {
        specialCaracter: false,
        mayus: false,
        correctLength: false,
        number: false
    }
};

const Settings = ({
    changePassword,
    fetchingChangePassword,
    cleanSettings,
    getPermissions,
    getPermissionType,
    changePermissions,
    fetchingChangePermissions,
    fetchingPermissionType,
    permissionType,
    permissions,
    loadNewPermission,
    fetchingLoadNewPermission
}: SettingsPageProps) => {
    const toast = useToast();
    const [open, setOpen] = useState<boolean>(false);
    const [marketingConsent, setMarketingConsent] = useState<boolean>(false);
    const [currentPassword, setCurrentPassword] = useState<{ value: string; error: string }>({ value: "", error: "" });
    const [newPassword, setNewPassword] = useState<any>(emptyPassState);
    const [confirmPassword, setConfirmPassword] = useState<any>(emptyPassState);

    const isSaveEnabled =
        currentPassword.value.length > 0 &&
        newPassword.value.length > 0 &&
        confirmPassword.value.length > 0;

    const handleToggleMarketing = (value: boolean) => {
        setMarketingConsent(value);
        if (permissionType?.data?.permissiongrants_type[0]?._id) {
            loadNewPermission(permissionType?.data?.permissiongrants_type[0]?._id, value);
        } else {
            changePermissions(permissions?.permission_grants[0]?._id, value);
        }
    };

    const handleChangePassword = () => {
        if (newPassword.value !== confirmPassword.value) {
            setConfirmPassword({ ...confirmPassword, error: "Las contraseñas no coinciden" });
            return;
        }
        changePassword(newPassword.value);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentPassword({ value: "", error: "" });
        setNewPassword(emptyPassState);
        setConfirmPassword(emptyPassState);
    };

    useEffect(() => {
        switch (fetchingChangePassword) {
            case 'failure':
                toast('Error al cambiar contraseña');
                handleClose();
                break;
            case 'success':
                toast('Contraseña cambiada correctamente');
                handleClose();
                break;
            default:
                break;
        }
    }, [fetchingChangePassword]);

    useEffect(() => {
        if (fetchingChangePermissions === 'success' || fetchingLoadNewPermission === 'success') {
            toast('Permisos cambiados correctamente');
        }
    }, [fetchingChangePermissions, fetchingLoadNewPermission]);

    useEffect(() => {
        return () => {
            cleanSettings();
        };
    }, []);

    useEffect(() => {
        getPermissions();
    }, [getPermissions]);

    useEffect(() => {
        if (permissions?.permission_grants?.length === 0) {
            getPermissionType("marketing", "register");
        } else if (permissions?.permission_grants) {
            setMarketingConsent(permissions?.permission_grants[0]?.granted);
        }
    }, [permissions]);

    return (
        <div className={styles.panel}>
            <div className={styles.panelHeader}>
                <span className={styles.panelTitle}>Ajustes de privacidad y comunicaciones</span>
            </div>
            <div className={styles.settingsList}>
                <div className={styles.settingsItem} onClick={() => setOpen(prev => !prev)}>
                    <div className={styles.itemLeft}>
                        <Icon path={mdiLockOutline} className={styles.itemIcon} />
                        <span className={styles.itemLabel}>Cambiar Contraseña</span>
                    </div>
                    <Icon path={open ? mdiChevronDown : mdiChevronRight} className={styles.chevronIcon} />
                </div>
                {open && (
                    <div className={styles.accordion}>
                        <div className={styles.accordionFields}>
                            <TextFieldShared
                                type="password"
                                label="Contraseña actual"
                                name="currentPassword"
                                value={currentPassword.value}
                                error={currentPassword.error}
                                onChange={(value: any) => setCurrentPassword({ value: value?.value, error: "" })}
                            />
                            <TextFieldShared
                                type="password"
                                label="Nueva contraseña"
                                name="newPassword"
                                value={newPassword.value}
                                error={newPassword.error}
                                onChange={(value: any) => setNewPassword({ ...newPassword, value: value?.value, validation: value?.passValidate })}
                            />
                            <TextFieldShared
                                type="password"
                                label="Repetir nueva contraseña"
                                name="confirmPassword"
                                value={confirmPassword.value}
                                error={confirmPassword.error}
                                onChange={(value: any) => setConfirmPassword({ ...confirmPassword, value: value?.value, validation: value?.passValidate })}
                            />
                        </div>
                        <div className={styles.accordionButtons}>
                            <button type="button" className={styles.cancelBtn} onClick={handleClose}>Cancelar</button>
                            <button type="button" className={styles.saveBtn} onClick={handleChangePassword} disabled={!isSaveEnabled || fetchingChangePassword === 'loading'}>
                                {fetchingChangePassword === 'loading' ? 'Guardando...' : 'Guardar'}
                            </button>
                        </div>
                    </div>
                )}
                <div className={styles.settingsItem}>
                    <div className={styles.itemLeft}>
                        <Icon path={mdiEmailOutline} className={styles.itemIcon} />
                        <span className={styles.itemLabel}>Recibir comunicaciones de marketing</span>
                    </div>
                    <label className={styles.toggle}>
                        <input
                            type="checkbox"
                            checked={marketingConsent}
                            onChange={(e) => handleToggleMarketing(e.target.checked)}
                        />
                        <span className={styles.toggleTrack} />
                    </label>
                </div>
            </div>
        </div>
    );
};

export default Settings;
